import { css } from 'lit';
import { IxAccountSwitcher } from './IxAccountSwitcher.js';
import { AccountSwitcherStyles } from './account-switcher-styles.js';

export class IxAccountSwitcherStyled extends IxAccountSwitcher {
  static override styles = [
    AccountSwitcherStyles,
    css`
      :host {
        --md-theme-primary: var(--md-sys-color-primary, blue);
      }
    `,
  ];
}

window.customElements.define('ix-account-switcher', IxAccountSwitcherStyled);
